import { render, staticRenderFns } from "./Reasign.vue?vue&type=template&id=6837b324&"
import script from "./Reasign.vue?vue&type=script&lang=js&"
export * from "./Reasign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports